if (!customElements.get('td-material-panel')) {
  class TdMaterialPanel extends HTMLElement {
    constructor() {
      super();
      // Bindings
      this.openDrawer = this.openDrawer.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);
      this.handleEscape = this.handleEscape.bind(this);
    }

    connectedCallback() {
      // Get elements from light DOM
      this.drawer = this.querySelector('.td-swatch-drawer');
      this.backdrop = this.querySelector('.td-swatch-drawer-backdrop');
      this.closeBtn = this.querySelector('.td-swatch-drawer-close');
      this.titleEl = this.querySelector('[data-swatch-drawer-title]');
      this.groupEl = this.querySelector('[data-swatch-drawer-group]');
      this.familyEl = this.querySelector('[data-swatch-drawer-family]');
      this.descEl = this.querySelector('[data-swatch-drawer-description]');
      this.bestForEl = this.querySelector('[data-swatch-drawer-bestfor]');
      this.detailsEl = this.querySelector('[data-swatch-details]');
      this.imageEl = this.querySelector('[data-swatch-drawer-image]');
      this.iconsEl = this.querySelector('[data-swatch-drawer-icons]');

      // Listen for swatch image wrapper clicks in the main DOM
      document.querySelectorAll('.td-material-information__swatch-image-wrapper').forEach(wrapper => {
        wrapper.addEventListener('click', this.openDrawer);
      });

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeDrawer);
      if (this.backdrop) this.backdrop.addEventListener('click', this.closeDrawer);
      document.addEventListener('keydown', this.handleEscape);
    }

    disconnectedCallback() {
      document.querySelectorAll('.td-material-information__swatch-image-wrapper').forEach(wrapper => {
        wrapper.removeEventListener('click', this.openDrawer);
      });
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.closeDrawer);
      if (this.backdrop) this.backdrop.removeEventListener('click', this.closeDrawer);
      document.removeEventListener('keydown', this.handleEscape);
    }

    openDrawer(e) {
      if (e) e.preventDefault();
      // Get data from clicked swatch
      const wrapper = e.currentTarget || (e.target && e.target.closest('.td-material-information__swatch-image-wrapper'));
      if (wrapper) {
        if (this.titleEl) {
          let titles = wrapper.dataset.fabricTitle
            ? wrapper.dataset.fabricTitle.split(' ').map(name => name.trim())
            : [];

          if (titles.length > 1) {
            const firstWord = titles[0];
            const rest = titles.slice(1).join(' ');
            this.titleEl.innerHTML = `<span>${firstWord.replace('-', ' ') || ''}</span> / ${rest || ''}`.trim();
          } else {
            this.titleEl.textContent = wrapper.dataset.fabricTitle || '';
          }
        }
        if (this.descEl) this.descEl.textContent = wrapper.dataset.description || '';
        // Set detail fields
        if (this.detailsEl) {
          const isLeather = wrapper.dataset.isLeather === '1';
          const detailsMap = {
            "composition": wrapper.dataset.content ? this.capitalizeWords(wrapper.dataset.content) : "",
            "rub-count": wrapper.dataset.rubCount ? this.addCommas(wrapper.dataset.rubCount) : "",
            "care": wrapper.dataset.cleaningCode || "",
            "qualities": wrapper.dataset.bestFor ? this.capitalizeWords(wrapper.dataset.bestFor) : "",
            "finish-type": isLeather && wrapper.dataset.finish ? this.capitalizeWords(wrapper.dataset.finish) : ""
          };
          this.detailsEl.querySelectorAll('.td-swatch-drawer-detail').forEach(detailEl => {
            const key = detailEl.getAttribute('data-detail');
            const valueEl = detailEl.querySelector('.td-swatch-drawer-detail-value');

            // Only show finish-type for leather items
            if (key === 'finish-type') {
              if (isLeather && detailsMap[key]) {
                detailEl.style.display = '';
                if (valueEl) valueEl.textContent = detailsMap[key];
              } else {
                detailEl.style.display = 'none';
                if (valueEl) valueEl.textContent = '';
              }
            } else {
              if (detailsMap[key]) {
                detailEl.style.display = '';
                if (valueEl) valueEl.textContent = detailsMap[key];
              } else {
                detailEl.style.display = 'none';
                if (valueEl) valueEl.textContent = '';
              }
            }
          });
        }
        if (this.imageEl) {
          this.imageEl.src = wrapper.dataset.image || '';
          this.imageEl.alt = wrapper.dataset.fabricTitle || '';
        }
        if (this.familyEl) {
          this.familyEl.textContent = wrapper.dataset.familyName || '';
        }
        // Render icons above image
        if (this.iconsEl) {
          // Hide all icons by default
          this.iconsEl.querySelectorAll('.td-material-information__feature-icon').forEach(iconEl => {
            iconEl.style.display = 'none';
          });
          // Show only relevant icons
          const bestFor = (wrapper.dataset.bestFor || '').split(',').map(s => s.trim().toLowerCase());
          bestFor.forEach(tag => {
            const iconEl = this.iconsEl.querySelector(`.td-material-information__feature-icon[data-icon="${tag.replace(' ', '-')}"]`);
            if (iconEl) iconEl.style.display = '';
          });
        }
      }
      if (this.drawer) this.drawer.classList.add('active');
      if (this.backdrop) this.backdrop.classList.add('active');
      document.documentElement.classList.add('swatch-drawer-visible');
    }

    addCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    capitalizeWords(sentence) {
      return sentence
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
    }

    closeDrawer() {
      if (this.drawer) this.drawer.classList.remove('active');
      if (this.backdrop) this.backdrop.classList.remove('active');
      document.documentElement.classList.remove('swatch-drawer-visible');
    }

    handleEscape(e) {
      if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('active')) {
        this.closeDrawer();
      }
    }
  }

  customElements.define('td-material-panel', TdMaterialPanel);
}
